var React = require('react');

function ClockInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7.46618","cy":"7.46667","r":"6.46667","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"5.82291","y":"4.82923","width":"0.800001","height":"3.46666","rx":"0.4","transform":"rotate(-15 5.82291 4.82923)","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.8","key":1}),React.createElement("rect",{"x":"6.79941","y":"8.66665","width":"0.8","height":"2.79534","rx":"0.4","transform":"rotate(-90 6.79941 8.66665)","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.8","key":2})]);
}

ClockInline.defaultProps = {"fill":"none"};

module.exports = ClockInline;

ClockInline.default = ClockInline;
